import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowLeft from "../images/ArrowLeft.png";
import listicon from "../images/listicon.webp";

const HeaderBar = ({ title, showSearch = true, onSearchClick, showList = false, onListClick ,  backPath = null ,  backState = null

 }) => {
  const navigate = useNavigate();

   const handleBack = () => {
    if (backPath) {
      navigate(backPath, { state: backState });  // ✅ PASS STATE HERE
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="sticky top-0 bg-white z-30 border-b border-gray-200 px-1 flex items-center justify-between h-14">
      {/* Left Section: Back Arrow + Title */}
      <div className="flex items-center gap-1">
             <button onClick={handleBack} className="flex items-center justify-center">
          <img
            src={ArrowLeft}
            alt="Back"
            className="w-12 h-8 object-contain"
          />
        </button>
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
      </div>

      {/* Right Section: List Icon or Search Icon or Empty */}
      {showList ? (
   <button
  onClick={onListClick}
  className="relative group p-0 rounded-full  shadow-sm hover:shadow-md transition-all duration-300 active:scale-90 mr-2 flex items-center justify-center hover:ring-gray-400"
>
  {/* Red bouncing dot */}
  <div className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full animate-pulse z-20"></div>

  {/* Blue hover overlay */}
  <div className="absolute inset-0 rounded-full bg-blue-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

  {/* Icon wrapper (GRAY BG + PADDING + CENTERED) */}
  <div className="p-2 rounded-full bg-gray-100 relative z-10 flex items-center justify-center">
    <img
      src={listicon}
      alt="List"
      className="w-6 h-6 object-contain group-hover:scale-110 transition-transform duration-300 ease-out"
    />
  </div>
</button>

      ) : showSearch ? (
        <button
          onClick={onSearchClick}
          className="p-2 rounded-full hover:bg-gray-100 transition mr-2 flex items-center justify-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-gray-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-4.35-4.35M17 10.5A6.5 6.5 0 1 1 4 10.5a6.5 6.5 0 0 1 13 0z"
            />
          </svg>
        </button>
      ) : (
        // Empty placeholder to preserve layout height and spacing
        <div className="w-10 h-10 mr-2" />
      )}
    </div>
  );
};

export default HeaderBar;
